import React from 'react';
import { HeroSection } from '../components/blocks/HeroSection';
import { CooperationTicker } from '../components/blocks/CooperationTicker';
import { ValuationMatrix } from '../components/blocks/ValuationMatrix';
import { MarketReality } from '../components/blocks/MarketReality';
import { CaseStudyGoldenMile } from '../components/blocks/CaseStudyGoldenMile';
import { ApproachBridge } from '../components/blocks/ApproachBridge';
import { DealReadinessAssessment } from '../components/blocks/DealReadinessAssessment';
import { StrategicFork } from '../components/blocks/StrategicFork';
import { AdaptiveRemediation } from '../components/blocks/AdaptiveRemediation';
import { ClinicOS } from '../components/blocks/ClinicOS';
import { CascadeExit } from '../components/blocks/CascadeExit';
import { ConfidentialityGateway } from '../components/blocks/ConfidentialityGateway';
import { MASyndicate } from '../components/blocks/MASyndicate';
import { MarketPrecedents } from '../components/blocks/MarketPrecedents';
import { KnowledgeVault } from '../components/blocks/KnowledgeVault';
import { StrategicInquiries } from '../components/blocks/StrategicInquiries';
import { SecureGatewayFooter } from '../components/blocks/SecureGatewayFooter';

export function Page() {
  return (
    <div className="w-full min-h-screen bg-[#FAF8F5] text-[#141416]">
      {/* 01. СТАТУС & ПЕРВЫЙ ЭКРАН */}
      <HeroSection id="vault" />
      <CooperationTicker />

      {/* 02. СИМУЛЯТОР МУЛЬТИПЛИКАТОРА */}
      <ValuationMatrix id="valuation-matrix" />

      {/* 03. РЫНОЧНЫЙ ШОК И РЕАЛЬНОСТЬ 2026 */}
      <MarketReality id="market-reality" />

      {/* 04. АНАТОМИЯ СРЫВА: КЕЙС ОСТОЖЕНКИ */}
      <CaseStudyGoldenMile id="case-study" />

      {/* 05. МОСТ МЕТОДОЛОГИИ S&P */}
      <ApproachBridge id="approach" />

      {/* 06. ОЦЕНКА ГОТОВНОСТИ К СДЕЛКЕ */}
      <DealReadinessAssessment id="diagnostic" />

      {/* 07. СТРАТЕГИЧЕСКАЯ РАЗВИЛКА */}
      <StrategicFork id="fork" />

      {/* 08. АДАПТИВНАЯ РЕМЕДИАЦИЯ */}
      <AdaptiveRemediation id="remediation" />

      {/* 09. ОПЕРАЦИОННАЯ СИСТЕМА CLINICOS */}
      <ClinicOS id="clinicos" />

      {/* 10. КАСКАДНЫЙ ВЫХОД & ДИЛЕММА МАСШТАБА */}
      <CascadeExit id="exit-strategy" />

      {/* 11. ШЛЮЗ КОНФИДЕНЦИАЛЬНОСТИ & 4 СТУПЕНИ ЗАЩИТЫ */}
      <ConfidentialityGateway id="confidentiality" />

      {/* 12. СИНДИКАТ M&A-ЭКСПЕРТИЗЫ */}
      <MASyndicate id="syndicate" />

      {/* 13. РЕЕСТР ПРЕЦЕДЕНТОВ & ТОМБСТОУНЫ */}
      <MarketPrecedents id="precedents" />

      {/* 14. АРХИВ МЕМОРАНДУМОВ & KNOWLEDGE VAULT */}
      <KnowledgeVault id="vault-docs" />

      {/* 15. СНЯТИЕ ПАРАНОЙИ (FAQ) */}
      <StrategicInquiries id="faq" />

      {/* 16. ЗАЩИЩЕННЫЙ ШЛЮЗ & ВИДЕО-БРИФ */}
      <SecureGatewayFooter id="gateway" />
    </div>
  );
}

export default Page;


